import * as React from 'react'
import cx from 'classnames'
import styles from './FormRow.m.sass'

interface Props extends React.HTMLAttributes<HTMLDivElement> {}

export default function FormRow({ children, className, ...rest }: Props) {
  return (
    <div className={cx(styles.root, className)} {...rest}>
      {children}
    </div>
  )
}
